// extracted by mini-css-extract-plugin
export default {"TwoDimsListFeature":"wv_a bii_b","TwoDimsListFeature__item":"wv_b bii_we","TwoDimsListFeature__item__text":"wv_c bii_vt"};